
import MapLeaflet from './MapLeaflet';
import MapGMap from './MapGMap';

// window.initMap = initMap;
// require("expose-loader?initMap");

export function init() {
  $(document).ready(() => {
    MapLeaflet.init( $('[data-map-provider=leaflet][data-latitude][data-longitude]') );
    MapGMap.init( $('[data-map-provider=gmap][data-latitude][data-longitude]') );
  });
}



// WEBPACK FOOTER //
// ./scripts/util/map.js